// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"71c0cf8d","160":"b807b018","208":"ef392253","293":"80acd9ba","453":"e10fc32f","516":"f5f61ac9","519":"085e1c5a","917":"65833951","946":"e67f2b21"}[chunkId] + ".chunk.js";
};